import { c as _c } from "react/compiler-runtime";
import React from 'react';
import loadable from '@loadable/component';
import Placeholder from 'components/consumer/Placeholder';
import usePDPBasicDetails from './state/context/usePDPBasicDetails';
import PDPInfoTable from './PDPInfoTable';
import PDPDeferredSection from './PDPDeferredSection';
import PDPShippingDimensionsPlaceholder from './PDPShippingDimensionsPlaceholder';
const DIMENSION_ATTRIBUTE_GROUPS = [['width', 'depth', 'height'], ['seat_width', 'seat_depth', 'seat_height'], ['arm_width', 'arm_height']];
const hasDimensionCode = value => typeof value === 'string' && value.split(',').some(code => code.trim());

// Matches PDPDimensionsImage: Cylindo shots render at both breakpoints, a
// static image renders only at the breakpoint that has a URL.
export const getDimensionImageReservation = product => {
  const details = product ?? {};
  const customProperties = details.custom_properties;
  const hasCylindoShots = !!details.id && !!customProperties?.cylindo_product && hasDimensionCode(customProperties?.cylindo_dimension_code);
  const mobile = hasCylindoShots || !!customProperties?.dimensional_image_mobile;
  const desktop = hasCylindoShots || !!customProperties?.dimensional_image_desktop;
  if (mobile && desktop) return 'both';
  if (mobile) return 'mobile';
  if (desktop) return 'desktop';
  return null;
};
export const getDimensionRowCount = attributes => {
  if (!attributes) return DIMENSION_ATTRIBUTE_GROUPS.length + 1;
  const valueFor = code => attributes.find(attribute => attribute.code === code)?.value;
  const standardRows = DIMENSION_ATTRIBUTE_GROUPS.filter(group => group.some(code => valueFor(code))).length;
  const weightRows = parseInt(valueFor('weight') || '', 10) ? 1 : 0;
  const rowCount = standardRows + weightRows;
  const additional = valueFor('other_dimensions');
  if (!additional) return rowCount;
  try {
    const dimensions = JSON.parse(additional);
    return rowCount + (Array.isArray(dimensions) ? dimensions.length : 0);
  } catch {
    return rowCount;
  }
};
const DimensionsHeadingPlaceholder = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <h2 className="text-xl font-bold text-gray"><Placeholder loading={true} type="rect" style={{
        height: "22px",
        width: "220px"
      }} /></h2>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const IMAGE_RESERVATION_CLASS = {
  both: 'w-full aspect-square lg:aspect-[4/3] mt-6 mb-4 lg:m-0',
  mobile: 'w-full aspect-square mt-6 mb-4 lg:hidden',
  desktop: 'hidden w-full lg:block lg:aspect-[4/3] lg:m-0'
};
const DimensionsPlaceholder = t0 => {
  const $ = _c(9);
  const {
    rowCount,
    imageReservation: t1
  } = t0;
  const imageReservation = t1 === undefined ? null : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="items-center flex justify-between"><DimensionsHeadingPlaceholder /></div>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== imageReservation) {
    t3 = imageReservation && <div className={IMAGE_RESERVATION_CLASS[imageReservation]} aria-hidden="true" />;
    $[1] = imageReservation;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== rowCount) {
    t4 = <div className="max-w-[480px] mx-auto"><PDPInfoTable loading={true} placeholderRowCount={rowCount} matchContentSize={true} /></div>;
    $[3] = rowCount;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <PDPShippingDimensionsPlaceholder />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t3 || $[7] !== t4) {
    t6 = <div data-xc="PDPDimensionsPlaceholder" className="[border-top:1px_solid_#e5e5e5] mt-14 pt-14">{t2}{t3}{t4}{t5}</div>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
};
const PDPDimensionsAndDetails = loadable(() => import('./PDPDimensionsAndDetails'));
const PDPDeferredDimensions = () => {
  const $ = _c(10);
  const {
    data
  } = usePDPBasicDetails();
  const t0 = data?.attributes;
  let t1;
  if ($[0] !== t0) {
    t1 = getDimensionRowCount(t0);
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const rowCount = t1;
  let t2;
  if ($[2] !== data || $[3] !== rowCount) {
    t2 = rowCount ? <DimensionsPlaceholder rowCount={rowCount} imageReservation={getDimensionImageReservation(data)} /> : null;
    $[2] = data;
    $[3] = rowCount;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const fallback = t2;
  let t3;
  if ($[5] !== fallback) {
    t3 = <PDPDimensionsAndDetails fallback={fallback} loadingFallback={fallback} />;
    $[5] = fallback;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== fallback || $[8] !== t3) {
    t4 = <PDPDeferredSection fallback={fallback}>{t3}</PDPDeferredSection>;
    $[7] = fallback;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export default PDPDeferredDimensions;